module.exports = __webpack_public_path__ + "static/media/cashcheck.5e418bba.png";